module.exports = __webpack_public_path__ + "static/childcouncil_card_img1@2x-752f9b075b969af823a31158b1626496.jpg";